// extracted by css-extract-rspack-plugin
export default {"cls1":"Search-cls1_xPJ","cls2":"Search-cls2_LsW Search-cls1_xPJ"};